export default __webpack_public_path__ + "static/media/sebi.a77a4794.svg";